import { closeContext, createContext } from "@otto-ec/tracking-bct";
import { sheetScope } from "../utils/props";
import type { useExternalContent } from "../content/loader.svelte";
import type { OcSheetV1VisibilityState } from "./visibility.svelte";

const log = /*           */ sheetScope.scope("tracking");

/**
 *
 *
 *
 *
 *
 *
 */
/*                                                                        */
export const useTrackingContext = (
  init: { sheetId: () => string },
  visibilityState: OcSheetV1VisibilityState,
  externalContent: ReturnType<typeof useExternalContent>,
): void => {
  const { sheetId } = init;
  /**
 *
 */
  let contextOpen = false;
  let contextTracked = false;

  /*           */
  //
  $effect(() => {
    const isDisplay = visibilityState.isDisplay;
    const { validUrl, rawContent } = externalContent;

    /*                                                      */
    /*                                                  */
    if (!isDisplay || !sheetId() || !validUrl || rawContent === null || contextTracked) return;

    if (import.meta.env.DEV) log.info("Creating tracking context for sheet", sheetId(), validUrl);
    createContext(sheetId(), validUrl, { ts_OttoComponent: ["sheet@v1"] });

    contextTracked = true;
    contextOpen = true;
  });

  /*            */
  //
  $effect(() => {
    const { validUrl, rawContent } = externalContent;

    /*                                                                                                 */
    if ((visibilityState.isDisplay && rawContent !== null) || !contextOpen) return;

    if (import.meta.env.DEV) log.info("Closing tracking context for sheet", sheetId, validUrl);
    closeContext();

    contextOpen = false;
  });

  /*                       */
  //
  $effect(() => {
    if (externalContent.rawContent) return;
    contextTracked = false;
  });
};
